module.exports = __webpack_public_path__ + "media/images/illustrations/illustration-1-cropped-319fc2ecd9039380370d32b91e3fd64e.png";